
import { Component, Prop, Vue } from 'vue-property-decorator';

import {getPartyTitles} from "../fillForm1/PartyTitles"
import { namespace } from "vuex-class";
import "@/store/modules/information";
import { locationsInfoType } from '@/types/Common';
const informationState = namespace("Information");

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import { form1DataInfoType, manualSopInfoType, form1PartiesInfoType } from '@/types/Information/Form1';

@Component({
    components:{       
        CheckBox,
        UnderlineForm            
    }
})
export default class Form1Layout extends Vue {

    @Prop({required:true})
    result!: form1DataInfoType; 

    @Prop({required: true})
    manualNTrib!: boolean

    @Prop({required: true})
    manualTrib!: boolean

    @Prop({required: true})
    manualNorm!: boolean

    @Prop({required: true})
    normalForm!: boolean

    @informationState.State
    public caseLocation: locationsInfoType;

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void
    
    dataReady = false;   
    applicantNames: string[] = [];
    respondentNames: string[] = [];

    // caseSop :manualSopInfoType[] = [];
    // noRolePartySop: manualSopInfoType[] = [];    

    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }

   
    public extractInfo(){
        
        const parties = this.result.parties
        this.applicantNames = [];
        this.respondentNames = [];
        
        for(const party of parties){
            
            if(party.appealRole=="Appellant")
                this.applicantNames.push(getPartyTitles(party, ' ', true))
            else if(party.appealRole=="Respondent")
                this.respondentNames.push(getPartyTitles(party, ' ', true))
        }
    }    
   
}

